import { exp } from "./export";
import { utils, HiddenCanvas } from '../utils.js';
import { lang } from '../lang.js';
import { settings } from '../settings.js';
import { isIOS } from "../core/environment";

exp.renderDiagram = ({chunk, options}) => {

    let goSmall = options.useSmallDiagram;

    let maxDiagramHeight = goSmall ? 65 : 40;

    let spacing = goSmall ? 20 : 32;
    exp.cursor.setScale(goSmall ? 0.6 : 1);
    exp.text.setScale(goSmall ? 0.6 : 1);
    let indentDistance = goSmall ? 10 : 28;
    let tabDistance = goSmall ? 52 : 82;

    // calculate chunk size

    let chunkWidth = chunk.width;
    let chunkHeight = Math.min(maxDiagramHeight, chunk.rows.length - chunk.startingRow);

    [exp.rt, exp.cursor, exp.text].forEach(element => element.setVisible(true));

    exp.rt.clear();

    // render beads on the RT

    // column numbers

    exp.text.setColor('#000').setAngle(90);

    for (let i = chunk.startingColumn; i < chunk.startingColumn + chunkWidth; i++) {
        let colPlace = {x: tabDistance + ((i - chunk.startingColumn) * spacing), y: indentDistance};
        let colNum = i + 1;
        exp.text.setText(colNum.toString());
        exp.rt.draw(exp.text, colPlace.x, colPlace.y);
    }

    exp.text.setAngle(0);

    for (let j = chunk.startingRow; j < chunk.startingRow + chunkHeight; j++) {

        // row number

        let rowPlace = {x: indentDistance, y: tabDistance + ((j - chunk.startingRow) * spacing)};
        let rowNum = j + 1;
        if (settings.pattern.rotateCamera) rowNum *= 2; // peyote rows doubled
        exp.text.setText(rowNum.toString()).setColor('#000');
        exp.rt.draw(exp.text, rowPlace.x, rowPlace.y);

        // row content

        for (let i = chunk.startingColumn; i < chunk.startingColumn + chunkWidth; i++) {

            let place = {
                x: tabDistance + ((i - chunk.startingColumn) * spacing),
                y: tabDistance + ((j - chunk.startingRow) * spacing)
            };

            // deal with offset

            if (settings.pattern.name !== 'loom') {
                if (settings.pattern.rotateCamera) {
                    place.y -= exp.offsetPattern[i] * (spacing / 2);
                } else {
                    place.x -= exp.offsetPattern[j] * (spacing / 2);
                }
            }

            let bead = chunk.rows[j][i - chunk.stripStartingColumn];
            if (bead !== undefined) {
                exp.cursor.setFillStyle(bead.fillColor);
                exp.rt.draw(exp.cursor, place.x, place.y);
                exp.text.setText(bead.letterCode).setColor(bead.whiteOrBlack);
                exp.rt.draw(exp.text, place.x, place.y);
            }
        };
    };

    // get the RT canvas data and return it as an image node for PDF

    let imageDimensions = {
        width: 100 + chunkWidth * spacing,
        height: 100 + chunkHeight * spacing
    };

    let hidden = new HiddenCanvas(imageDimensions.width, imageDimensions.height);

    let x = 0, y = 0, w = imageDimensions.width, h = imageDimensions.height;

    if (isIOS || window.safari) {
        [x, y, w, h] = utils.safariDraw(x, y, w, h, exp.rt.canvas);
    }

    if (w > 0 && h > 0) {
        hidden.ctx.drawImage(exp.rt.canvas,
            x, y, w, h,
            0, 0, imageDimensions.width, imageDimensions.height,
        );
    }


    let result = hidden.canvas.toDataURL();

    hidden.remove();

    [exp.rt, exp.cursor, exp.text].forEach(element => element.setVisible(false));

    let myWidth = imageDimensions.width / 2.2;

    let obj = {
        image: result,
        width: myWidth,
    };

    return obj;
};

exp.getDiagrams = ({strip, options}) => {

    let result = [];

    let maxDiagramWidth = options.useSmallDiagram ? 50 : 30;
    let maxDiagramHeight = options.useSmallDiagram ? 65 : 40;

    // work out how many diagrams we'll need to split the panel up into

    let dCols = Math.floor((strip.width - 1) / maxDiagramWidth) + 1;
    let dRows = Math.floor((strip.rows.length - 1) / maxDiagramHeight) + 1;

    // create RT and cursor (first time only)

    if (exp.rt === undefined) exp.createRT();

    for (let i = 0; i < dCols; i++) {
        for (let j = 0; j < dRows; j++) {
            let chunk = {
                startingRow: j * maxDiagramHeight,
                startingColumn: strip.startColumn + (i * maxDiagramWidth), // OK
                stripStartingColumn: strip.startColumn,
                rows: strip.rows,
                width: Math.min(maxDiagramWidth, strip.endColumn - (strip.startColumn + (i * maxDiagramWidth)))
            };

            result.push(exp.renderDiagram({chunk, options}));
        }
    }

    return result;
};

exp.getDiagramsOnly = ({options}) => {
    if (settings.pattern.noDiagrams) return null;
    if (settings.pattern.simpleExport) return null;

    let result = [];

    let strips = exp.getStrips({options}); // returns an array of strips. each strip contains an array of beads and extra info
    let header;

    strips.forEach(strip => {
        let myDiagrams = exp.getDiagrams({strip, options});

        myDiagrams.forEach((diagram, i) => {
            header = lang.get('pattern diagram', 'Pattern Diagram');

            if (strips.length > 1) header += ' ' + lang.get('referring to a panel in pdf export', 'for panel') + ' ' + strip.stripNumber.toString();
            if (myDiagrams.length > 1) {
                let myCount = i + 1;
                header += ' (' + myCount.toString() + ' of ' + myDiagrams.length.toString() + ')';
            }
            result.push(exp.getTextContent(header, 'headerBreak'));
            result.push(diagram);
        });
    });

    return result;
};